import Vue from 'vue'

const state = Vue.observable({
  isLoading: false,
  loadingText: '加载中...'
})

export function useLoading() {
  return {
    isLoading: () => state.isLoading,
    loadingText: () => state.loadingText,
    showLoading: (text = '加载中...') => {
      state.loadingText = text
      state.isLoading = true
    },
    hideLoading: () => {
      state.isLoading = false
    }
  }
}

export default {
  install(Vue) {
    Vue.prototype.$loading = useLoading
  }
}
